import { context, DiProcess, universalAdPackage } from '@wikia/ad-engine';
import { Injectable } from '@wikia/dependency-injection';

@Injectable()
export class GamespotSlotsContextSetup implements DiProcess {
	execute(): void {
		const slots = {
			interstitial: {
				adProduct: 'interstitial',
				adUnit:
					'/{custom.dfpId}/{slotConfig.group}/{slotConfig.adProduct}' +
					'/{custom.device}{custom.region}-{custom.property}{custom.pagePath}',
				group: 'IU',
				outOfPage: true,
				outOfPageFormat: 'INTERSTITIAL',
				targeting: {
					loc: 'hivi',
				},
			},
			top_leaderboard: {
				firstCall: true,
				adProduct: 'top_leaderboard',
				group: 'LB',
				sizes: [
					{
						viewportSize: [970, 200],
						sizes: [
							[728, 90],
							[970, 250],
							[970, 66],
							universalAdPackage.UAP_ADDITIONAL_SIZES.bfaSize.desktop,
						],
					},
					{
						viewportSize: [840, 200],
						sizes: [[728, 90], universalAdPackage.UAP_ADDITIONAL_SIZES.bfaSize.desktop],
					},
					{
						viewportSize: [320, 200],
						sizes: [[320, 50], [320, 100], universalAdPackage.UAP_ADDITIONAL_SIZES.bfaSize.mobile],
					},
					{
						viewportSize: [0, 0],
						sizes: [[320, 50]],
					},
				],
				defaultSizes: [
					[728, 90],
					[970, 250],
				],
				defaultTemplates: ['stickyTlb'],
				targeting: {
					loc: 'top',
					pos_nr: 'nav',
				},
				slotRefreshing: true,
			},
			floor_adhesion: {
				adProduct: 'floor_adhesion',
				group: 'PF',
				targeting: {
					loc: 'footer',
				},
				defaultTemplates: ['floorAdhesion'],
				defaultSizes: [[728, 90]],
				sizes: [
					{
						viewportSize: [0, 0],
						sizes: [
							universalAdPackage.UAP_ADDITIONAL_SIZES.companionSizes.floor_adhesion_mobile.size,
							[300, 50],
							[320, 50],
							[320, 100],
						],
					},
					{
						// 728px for the ad + 40px width of the close button
						viewportSize: [768, 0],
						sizes: [
							universalAdPackage.UAP_ADDITIONAL_SIZES.companionSizes.floor_adhesion_desktop.size,
							[728, 90],
						],
					},
				],
				slotRefreshing: true,
			},
			mpu_top: {
				defaultSizes: [
					universalAdPackage.UAP_ADDITIONAL_SIZES.companionSizes.medrec.size,
					[300, 250],
				],
				targeting: {
					pos_nr: 'top',
				},
				slotRefreshing: true,
			},
			mpu_plus_top: {
				defaultSizes: [
					[300, 250],
					[300, 600],
				],
				targeting: {
					pos_nr: 'top',
				},
				slotRefreshing: true,
			},
			mpu_middle: {
				defaultSizes: [[300, 250]],
				targeting: {
					pos_nr: '1',
				},
				slotRefreshing: true,
			},
			mpu_bottom: {
				defaultSizes: [[300, 250]],
				targeting: {
					pos_nr: 'bottom',
				},
				slotRefreshing: true,
			},
			leader_plus_top: {
				defaultSizes: [
					[728, 90],
					[970, 66],
					[970, 250],
				],
				targeting: {
					pos_nr: 'top',
				},
				slotRefreshing: true,
			},
			leader_top: {
				defaultSizes: [
					[728, 90],
					[970, 66],
				],
				targeting: {
					pos_nr: 'top',
				},
				slotRefreshing: true,
			},
			leader_bottom: {
				defaultSizes: [
					[728, 90],
					[970, 66],
				],
				targeting: {
					pos_nr: 'bottom',
				},
				slotRefreshing: true,
			},
			overlay_leader_top: {
				defaultSizes: [
					[728, 90],
					[970, 66],
				],
				targeting: {
					pos_nr: 'top',
				},
				slotRefreshing: true,
			},
			overlay_mpu_top: {
				defaultSizes: [[300, 250]],
				targeting: {
					pos_nr: 'top',
				},
				slotRefreshing: true,
			},
			leader_middle: {
				defaultSizes: [
					[728, 90],
					[970, 66],
				],
				targeting: {
					pos_nr: '1',
				},
				slotRefreshing: true,
			},
			'sky-leader-plus-top': {
				defaultSizes: [
					[970, 250],
					[970, 66],
					[728, 90],
				],
				targeting: {
					pos_nr: '1',
				},
				slotRefreshing: true,
			},
			'incontent-ad': {
				defaultSizes: [
					[970, 66],
					[728, 90],
				],
				targeting: {
					pos_nr: 'top',
				},
				slotRefreshing: true,
			},
			'incontent-ad-inc': {
				defaultSizes: [
					[970, 66],
					[728, 90],
				],
				targeting: {
					pos_nr: '1',
				},
				slotRefreshing: true,
			},
			'leader-plus-inc': {
				defaultSizes: [
					[970, 250],
					[970, 90],
					[970, 66],
					[728, 90],
				],
				targeting: {
					pos_nr: '1',
				},
				slotRefreshing: true,
			},
			'mpu-top-inc': {
				defaultSizes: [[300, 250]],
				targeting: {
					pos_nr: '1',
				},
				slotRefreshing: true,
			},
			'mpu-bottom-inc': {
				defaultSizes: [[300, 250]],
				targeting: {
					pos_nr: '1',
				},
				slotRefreshing: true,
			},
			'leader-bottom-inc': {
				defaultSizes: [
					[970, 66],
					[728, 90],
				],
				targeting: {
					pos_nr: '1',
				},
				slotRefreshing: true,
			},
			logo_top: {
				defaultSizes: [[160, 70]],
				targeting: {
					pos_nr: 'top',
				},
				slotRefreshing: true,
			},
			'mobile-native': {
				defaultSizes: [[300, 250]],
				targeting: {
					pos_nr: 'top',
				},
				slotRefreshing: true,
			},
			'mobile-incontent-ad': {
				defaultSizes: [
					[300, 250],
					[320, 50],
				],
				targeting: {
					pos_nr: 'top',
				},
				slotRefreshing: true,
			},
			'mobile-banner-bottom': {
				defaultSizes: [[320, 50]],
				targeting: {
					pos_nr: 'bottom',
				},
				slotRefreshing: true,
			},
			'mobile-mpu-bottom': {
				defaultSizes: [[300, 250]],
				targeting: {
					pos_nr: 'bottom',
				},
				slotRefreshing: true,
			},
			'mobile-native-plus-top': {
				defaultSizes: [[300, 250]],
				targeting: {
					pos_nr: 'top',
				},
				slotRefreshing: true,
			},
			'mobile-flex-bottom': {
				defaultSizes: [
					[300, 250],
					[320, 50],
				],
				targeting: {
					pos_nr: 'bottom',
				},
				slotRefreshing: true,
			},
			'mobile-autoplay-plus': {
				defaultSizes: [
					[300, 250],
					[320, 50],
				],
				targeting: {
					pos_nr: 'plus',
				},
				slotRefreshing: true,
			},
			'mobile-highimpact-plus': {
				defaultSizes: [
					[300, 250],
					[320, 50],
				],
				targeting: {
					pos_nr: 'plus',
				},
				slotRefreshing: true,
			},
			'incontent-mobile-flex': {
				defaultSizes: [
					[300, 250],
					[320, 50],
				],
				targeting: {
					pos_nr: '1',
				},
				slotRefreshing: true,
			},
			'mobile-banner': {
				defaultSizes: [[320, 50]],
				targeting: {
					pos_nr: '1',
				},
				slotRefreshing: true,
			},
			'mobile-mpu': {
				defaultSizes: [[300, 250]],
				targeting: {
					pos_nr: '1',
				},
				slotRefreshing: true,
			},
			'mobile-incontent-ad-inc': {
				defaultSizes: [
					[300, 250],
					[320, 50],
				],
				targeting: {
					pos_nr: '1',
				},
				slotRefreshing: true,
			},
			'mobile-flex-inc': {
				defaultSizes: [
					[300, 250],
					[320, 50],
				],
				targeting: {
					pos_nr: '1',
				},
				slotRefreshing: true,
			},
			'mobile-logo': {
				defaultSizes: [[160, 70]],
				targeting: {
					pos_nr: '1',
				},
				slotRefreshing: true,
			},
			'leader-ad-plus-top': {
				defaultSizes: [
					[728, 90],
					[970, 66],
					[970, 250],
				],
				targeting: {
					pos_nr: 'top',
				},
				slotRefreshing: true,
			},
			'leader-ad-plus-middle': {
				defaultSizes: [
					[728, 90],
					[970, 66],
					[970, 250],
				],
				targeting: {
					pos_nr: 'middle',
				},
				slotRefreshing: true,
			},
			'native-mpu': {
				defaultSizes: [
					[300, 250],
					// fluid
				],
				targeting: {
					pos_nr: 'native',
				},
				slotRefreshing: true,
			},
			'incontent-ad-plus-billboard-bottom': {
				defaultSizes: [
					[970, 250],
					[970, 66],
					[728, 90],
				],
				targeting: {
					pos_nr: 'bottom',
				},
				slotRefreshing: true,
			},
			'mobile-incontent-plus': {
				defaultSizes: [
					[300, 250],
					[320, 50],
				],
				targeting: {
					pos_nr: 'increment',
				},
				slotRefreshing: true,
			},
			'mobile-incontent-plus-bottom': {
				defaultSizes: [
					[300, 250],
					[320, 50],
				],
				targeting: {
					pos_nr: 'bottom',
				},
				slotRefreshing: true,
			},
			'mobile-banner-plus': {
				defaultSizes: [
					[300, 250],
					[320, 50],
				],
				targeting: {
					pos_nr: 'increment',
				},
				slotRefreshing: true,
			},
			'incontent-ad-plus-inc': {
				defaultSizes: [
					[728, 90],
					[970, 66],
				],
				targeting: {
					pos_nr: 'inc',
				},
				slotRefreshing: true,
			},
			'mobile-incontent-ad-plus-inc': {
				defaultSizes: [
					[300, 250],
					[320, 50],
				],
				targeting: {
					pos_nr: 'inc',
				},
				slotRefreshing: true,
			},
			'incontent-all-top': {
				defaultSizes: [
					[970, 250],
					[970, 66],
					[728, 90],
				],
				targeting: {
					pos_nr: 'top',
				},
				slotRefreshing: true,
			},
			'mobile-incontent-all': {
				defaultSizes: [
					[320, 480],
					[300, 250],
				],
				targeting: {
					pos_nr: 'increment',
				},
				slotRefreshing: true,
			},
			'incontent-narrow-all-top': {
				defaultSizes: [[728, 90]],
				targeting: {
					pos_nr: 'top',
				},
				slotRefreshing: true,
			},
			video: {
				isVideo: true,
			},
		};

		context.set('slots', slots);
	}
}
